import FieldsetPaymentGeneral from './FieldsetPaymentGeneral.yaml?component';
import UcPaymentHeader from './UcPaymentHeader.yaml?component';
import UcPaymentInvoices from './UcPaymentInvoices.yaml?component';

export {
  FieldsetPaymentGeneral,
  UcPaymentHeader,
  UcPaymentInvoices
};
